var accountSingleton;

import Account from '../models/account.js';


const init = function(accountData) {
    accountSingleton = new Account(accountData);
  };

const get = function() {
    if (!accountSingleton) {
      throw new Error('You must call `init` on `account` appglobal before calling `get`');
    }
    return accountSingleton;
  };


export { get, init };
export default { get, init };
